<div class="page-container">
    <div class="page-header">
        <div class="header-content">
            <h1 class="page-title">Bookings List</h1>
            <p class="page-subtitle">Manage your shipping orders and bookings</p>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-overlay">
        <mat-spinner diameter="50" color="primary"></mat-spinner>
        <p class="loading-text">Loading bookings...</p>
    </div>

    <div class="card" [class.loading]="isLoading">
        <div class="card-header">
            <div class="search-filter-group">
                

                <!-- Selection Type Filter -->
                <div class="filter-status-wrapper">
                    <button class="filter-status-btn filter-selection-btn" (click)="toggleFilterSelection($event)"
                        [class.active]="selectedSelectionType !== null">
                        <mat-icon>tune</mat-icon>
                        <span>{{ selectedSelectionLabel }}</span>
                        <mat-icon class="filter-chevron">expand_more</mat-icon>
                        <span *ngIf="selectedSelectionType !== null" class="filter-active-dot"></span>
                    </button>
                    <div *ngIf="filterSelectionOpen" class="filter-status-menu filter-selection-menu">
                        <button class="filter-status-item" [class.selected]="selectedSelectionType === null"
                            (click)="selectSelectionType(null)">
                            <mat-icon class="filter-check" *ngIf="selectedSelectionType === null">check</mat-icon>
                            <span class="filter-check-placeholder" *ngIf="selectedSelectionType !== null"></span>
                            <span>All</span>
                        </button>
                        <div class="filter-divider"></div>
                        <button *ngFor="let type of selectionTypes" class="filter-status-item"
                            [class.selected]="selectedSelectionType?.value === type.value"
                            (click)="selectSelectionType(type)">
                            <mat-icon class="filter-check" *ngIf="selectedSelectionType?.value === type.value">check</mat-icon>
                            <span class="filter-check-placeholder" *ngIf="selectedSelectionType?.value !== type.value"></span>
                            <span>{{ type.label }}</span>
                        </button>
                    </div>
                </div>
                <div class="search-wrapper">
                    <mat-icon class="search-icon">search</mat-icon>
                    <input type="text" class="search-input" [(ngModel)]="searchText"
                        [placeholder]="selectedSelectionType ? 'Search by ' + selectedSelectionType.label + '...' : 'Search by reference, customer, plate, driver...'"
                        (input)="onSearchInput()" />
                    <mat-icon *ngIf="searchText" class="clear-icon" (click)="clearSearch()">close</mat-icon>
                </div>

                <div class="filter-status-wrapper">
                <!-- <button class="filter-status-btn" (click)="toggleFilterStatus($event)" [class.active]="selectedFilterStatus !== null">
                    <mat-icon>filter_list</mat-icon>
                    <span>{{ selectedFilterStatusName }}</span>
                    <mat-icon class="filter-chevron">expand_more</mat-icon>
                    <span *ngIf="selectedFilterStatus !== null" class="filter-active-dot"></span>
                </button> -->
                <div *ngIf="filterStatusOpen" class="filter-status-menu">
                    <button class="filter-status-item" [class.selected]="selectedFilterStatus === null" (click)="selectFilterStatus(null)">
                        <mat-icon class="filter-check" *ngIf="selectedFilterStatus === null">check</mat-icon>
                        <span class="filter-check-placeholder" *ngIf="selectedFilterStatus !== null"></span>
                        <span>All Status</span>
                    </button>
                    <div class="filter-divider"></div>
                    <button *ngFor="let status of statusOptions" class="filter-status-item" [class.selected]="selectedFilterStatus === status.id" (click)="selectFilterStatus(status)">
                        <mat-icon class="filter-check" *ngIf="selectedFilterStatus === status.id">check</mat-icon>
                        <span class="filter-check-placeholder" *ngIf="selectedFilterStatus !== status.id"></span>
                        <span>{{ status.name }}</span>
                    </button>
                </div>
            </div>
            </div>

            <button type="button" class="btn-primary" (click)="addNewBooking()">
                <mat-icon>add_box</mat-icon>
                <span>Add Booking</span>
            </button>
        </div>

        <div class="table-container">
            <table class="data-table">
                <thead>
                    <tr>
                        <th style="width: 50px;"></th>
                        <th style="width: 140px;">Reference</th>
                        <th style="width: 220px;">Customer Name</th>
                        <th style="width: auto;">Delivery Location</th>
                        <th style="width: 130px;">Plate Number</th>
                        <th style="width: 140px;">Driver Name</th>
                        <th style="width: 130px;">Driver Phone</th>
                        <th style="width: 150px; text-align: left; padding-left: 40px;">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of filteredOrders" class="table-row" (click)="onViewBooking(data)" style="cursor: pointer;">
                        <td class="actions-cell" (click)="$event.stopPropagation()">
                            <button class="btn-icon-action" (click)="editConsignee(data)" title="More options">
                                <mat-icon>more_vert</mat-icon>
                            </button>

                            <div *ngIf="selectedBookingId === data.id" class="dropdown-menu">
                                <button class="dropdown-item" (click)="onEdit(data)">
                                    <mat-icon class="dropdown-icon edit-icon">edit</mat-icon>
                                    <span>Edit Booking</span>
                                </button>
                                <div class="dropdown-divider"></div>
                                <button class="dropdown-item dropdown-item-danger" (click)="onDelete(data)">
                                    <mat-icon class="dropdown-icon">delete</mat-icon>
                                    <span>Delete Booking</span>
                                </button>
                            </div>
                        </td>
                        <td>
                            <div class="booking-info">
                                <span class="booking-name">{{ data.reference }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="booking-info">
                                <!-- <div class="booking-avatar">
                                    <mat-icon>person</mat-icon>
                                </div> -->
                                <span class="booking-name">{{ data.customer.name }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="location-cell">
                                <mat-icon class="location-icon delivery">location_on</mat-icon>
                                <span *ngIf="!isLocationTruncated(data.deliveryLocation?.address)" class="location-text">{{ truncateLocation(data.deliveryLocation?.address) }}</span>
                                <div *ngIf="isLocationTruncated(data.deliveryLocation?.address)" class="location-expand-wrapper">
                                    <span class="location-text">{{ truncateLocation(data.deliveryLocation?.address) }}</span><button class="location-expand-btn" (click)="toggleLocationExpand(data.id, $event)" title="View full address">more</button>
                                    <div *ngIf="expandedLocationId === data.id" class="location-popover">
                                        <div class="location-popover-header">
                                            <mat-icon class="location-popover-icon">location_on</mat-icon>
                                            <span>Delivery Location</span>
                                        </div>
                                        <p class="location-popover-text">{{ data.deliveryLocation?.address }}</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="truck-cell">
                            <div *ngIf="data.assignedTruck" class="truck-plate">
                                <mat-icon class="truck-icon">local_shipping</mat-icon>
                                <span>{{ data.assignedTruck.plateNumber }}</span>
                            </div>
                            <span *ngIf="!data.assignedTruck" class="truck-empty">—</span>
                        </td>
                        <td class="truck-cell">
                            <div *ngIf="data.assignedTruck" class="truck-driver">
                                <mat-icon class="truck-icon">person</mat-icon>
                                <span>{{ data.assignedTruck.driverName }}</span>
                            </div>
                            <span *ngIf="!data.assignedTruck" class="truck-empty">—</span>
                        </td>
                        <td class="truck-cell">
                            <div *ngIf="data.assignedTruck" class="truck-phone">
                                <mat-icon class="truck-icon">phone</mat-icon>
                                <span>{{ data.assignedTruck.driverPhone }}</span>
                            </div>
                            <span *ngIf="!data.assignedTruck" class="truck-empty">—</span>
                        </td>
                        <td class="status-cell" style="padding-left: 40px;">
                            <div class="status-wrapper" style="display: inline-flex; align-items: center; gap: 6px; position: relative;">
                                <!-- Show Draft badge if isDraft is true -->
                                <span *ngIf="data.isDraft" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 6px 12px; border-radius: 20px; font-size: 12px; font-weight: 600; letter-spacing: 0.3px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); cursor: default;">DRAFT</span>

                                <!-- Show Status badge if isDraft is false -->
                                <ng-container *ngIf="!data.isDraft">
                                    <span class="status-badge" [ngClass]="getStatusClass(getStatusName(data.orderBookingStatus))"
                                        (click)="toggleStatusDropdown(data.id, $event)">
                                        {{ getStatusName(data.orderBookingStatus) }}
                                        <mat-icon class="status-dropdown-icon">arrow_drop_down</mat-icon>
                                    </span>

                                    <div *ngIf="selectedStatusDropdown === data.id" class="status-dropdown-menu" [class.open-upward]="statusDropdownOpenUpward" (click)="$event.stopPropagation()">
                                        <button *ngFor="let status of statusOptions" class="status-dropdown-item"
                                            [disabled]="status.id === data.orderBookingStatus" (click)="updateStatus(data, status, $event)">
                                            <mat-icon class="status-check-icon" *ngIf="status.id === data.orderBookingStatus">check</mat-icon>
                                            <span class="status-check-placeholder" *ngIf="status.id !== data.orderBookingStatus"></span>
                                            <span>{{ status.name }}</span>
                                        </button>
                                    </div>
                                </ng-container>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- Empty State -->
            <div *ngIf="filteredOrders.length === 0 && !isLoading" class="empty-state">
                <mat-icon class="empty-icon">inbox</mat-icon>
                <h3>No bookings found</h3>
                <p>Try adjusting your search or add a new booking</p>
            </div>
        </div>

        <div class="card-footer" *ngIf="filteredOrders.length > 0">
            <div class="pagination-info">
                Showing <strong>{{ filteredOrders.length }}</strong> of <strong>{{ datas.length }}</strong> bookings
            </div>
            <div class="pagination">
                <button class="pagination-btn" [disabled]="currentPage === 1"
                    (click)="getConsigneeList(currentPage - 1)" title="Previous page">
                    <mat-icon>chevron_left</mat-icon>
                </button>

                <ng-container *ngFor="let page of pages">
                    <button class="pagination-btn pagination-number"
                        [ngClass]="{ 'active': page === currentPage }" (click)="getConsigneeList(page)">
                        {{ page }}
                    </button>
                </ng-container>

                <button class="pagination-btn" [disabled]="currentPage === totalPages"
                    (click)="getConsigneeList(currentPage + 1)" title="Next page">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
